enum ActivityTab {
  Auctions = "Auctions",
  Notifications = "Notifications",
  Offers = "Offers",
}

export default ActivityTab;
